"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _uiTheme = require("@kyruus/ui-theme");
const DrawerComponent = (0, _uiTheme.withMuiThemeAdapter)(_Drawer.default);
const Drawer = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(DrawerComponent, props, children);
};
Drawer.propTypes = {
  /**
   * Side from which the drawer will appear
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the drawer
   */
  children: _propTypes.default.node,
  /**
   * Callback fired when the component requests to be closed.
   * Takes the event as its argument, returns void.
   */
  onClose: _propTypes.default.func,
  /**
   * If true, the drawer is open
   */
  open: _propTypes.default.bool,
  /**
   * The variant to use.
   * Permanent drawers are always open.
   * Persistent drawers can be toggled open or closed, and sit on the same level as the page contents.
   * Temporary drawers can be toggled open or closed, and sit above the page contents like a modal.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary']),
  /**
   * See https://material-ui.com/api/drawer/ for all available props
   */
  '...props': _propTypes.default.node
};
Drawer.defaultProps = {
  anchor: 'left',
  open: false,
  variant: 'temporary'
};
var _default = exports.default = Drawer;
Drawer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Drawer",
  "props": {
    "anchor": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "Side from which the drawer will appear",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'top'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }]
      },
      "required": false
    },
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, the drawer is open",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "variant": {
      "defaultValue": {
        "value": "'temporary'",
        "computed": false
      },
      "description": "The variant to use.\nPermanent drawers are always open.\nPersistent drawers can be toggled open or closed, and sit on the same level as the page contents.\nTemporary drawers can be toggled open or closed, and sit above the page contents like a modal.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'permanent'",
          "computed": false
        }, {
          "value": "'persistent'",
          "computed": false
        }, {
          "value": "'temporary'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "description": "The contents of the drawer",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onClose": {
      "description": "Callback fired when the component requests to be closed.\nTakes the event as its argument, returns void.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "...props": {
      "description": "See https://material-ui.com/api/drawer/ for all available props",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};